import AddApiGenerator from './addApi.js';
import RegionGenerator from './regionGenerator.js';
import RemoveApiGenerator from './removeApi.js';

export const generatorType = {
  addApiVersion: AddApiGenerator,
  regions: RegionGenerator,
  removeApiVersion: RemoveApiGenerator,
};
